import(/* webpackMode: "eager" */ "/vercel/path0/src/app/ethereals/page.tsx");
